// extracted by mini-css-extract-plugin
export default {"wrapper":"grIjH6b72eBqVMIEg9ja","title":"CSkxklxiGMTo2vR_MI78","description":"cEicHt9TUwRwUMdb8Y65","counter":"aA6QhyMdu64zYz9tcseC","capture":"GM0zCgrA5xzXDmLBozdN"};